import React, { useState, useEffect } from "react";
import DataTable from "../../../components/DataTable";
import { apiJson } from "../../../utils/api";

const Subjects = () => {
  const [faculties, setFaculties] = useState([]);

  useEffect(() => {
    apiJson("/api/admin/master/faculties").then(setFaculties).catch(() => {});
  }, []);

  return (
    <DataTable
      title="Subjects"
      apiPath="/api/admin/master/subjects"
      columns={[
        { key: "id", label: "ID" },
        { key: "name", label: "Name" },
        { label: "Faculty", render: (item) => item.faculty?.name || "-" },
      ]}
      formFields={[
        { key: "name", label: "Subject Name", required: true },
        {
          key: "facultyId",
          label: "Faculty",
          type: "select",
          required: true,
          options: faculties.map((f) => ({ value: f.id, label: f.name })),
        },
      ]}
    />
  );
};

export default Subjects;
